<template >
  <div :id="id" :style="snackBarStyles" class="">
    <span>{{ message }}</span>
    <span @click="hideSnackbar()" class="hide">Hide</span>
  </div>
</template>

<script>
export default {
  name: "SSnackbar",

  props: {
    message: {
      required: true,
      default: "Please write your display message here",
    },
    close: {
      default: false,
    },
    time:{
      default:3000
    },
    color:{
      type:String,
      default:"#fff"
    },
    background:{
      type:String,
      default:"#333"
    },
    borderColor:{
      type:String,
      default:"#333"
    }
  },

  computed:{
    snackBarStyles(){
      let fgC,bgC, bordC;
      if (
        this.background.indexOf("#") === 0 ||
        this.background.indexOf("r") === 0
      ) {
        bgC = this.background;
      } else {
        bgC = "var(--" + this.background + ")";
      }

      if (
        this.color.indexOf("#") === 0 ||
        this.color.indexOf("r") === 0
      ) {
        fgC = this.color;
      } else {
        fgC = "var(--" + this.color + ")";
      }

      if (
        this.borderColor.indexOf("#") === 0 ||
        this.borderColor.indexOf("r") === 0
      ) {
        bordC = this.borderColor;
      } else {
        bordC = "var(--" + this.borderColor + ")";
      }

      return{
        'background-color':bgC,
        color:fgC,
        'border-color':bordC
      }
    }
  },

  data() {
    return {
      id:"snackbar"
    };
  },

  methods: {
    hideSnackbar() {
      var x = document.getElementById("snackbar");
        x.className = x.className.replace("show", "");
     
    },
    defaultHideSnackbar() {
      var x = document.getElementById("snackbar");
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, this.time);
    },
  },

  mounted() {
    var x = document.getElementById("snackbar");
    x.className = "show";
    if (!this.close) {
      // console.log("ABC")
      this.defaultHideSnackbar();
    }
  },

  validations: function () {
    return {};
  },

};
</script>

<style lang="scss" scoped>
/* The snackbar - position it at the bottom and in the middle of the screen */
#snackbar {
  visibility: hidden; /* Hidden by default. Visible on click */
  width: calc(100% - 24px); /* Set a default minimum width */
  // margin-left: -250px; /* Divide value of min-width by 2 */
  background-color: #333; /* Black background color */
  color: #fff; /* White text color */
  // text-align: center; /* Centered text */
  border-radius: 2px; /* Rounded borders */
  padding: 16px; /* Padding */
  position: fixed; /* Sit on top of the screen */
  z-index: 1000000; /* Add a z-index if needed */
  left: 0; /* Center the snackbar */
  // bottom: 30px; /* 30px from the bottom */
  top: 0;
  display: flex;
  justify-content: space-between;
  // grid-template-columns: 1fr auto;
  align-items: center;
  border: 1px solid;
}

/* Show the snackbar when clicking on a button (class added with JavaScript) */
#snackbar.show {
  visibility: visible; /* Show the snackbar */
  /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
  However, delay the fade out process for 2.5 seconds */
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

.hide{
  text-decoration: underline;
  color: var(--white);
  // color: var(--primary);
  cursor: pointer;
}
.hide:hover{
  filter: invert(1);
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
  from {
    top: 0;
    opacity: 0;
  }
  to {
    top: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    top: 0;
    opacity: 0;
  }
  to {
    top: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    top: 30px;
    opacity: 1;
  }
  to {
    top: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    top: 30px;
    opacity: 1;
  }
  to {
    top: 0;
    opacity: 0;
  }
}
</style>